import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const OrderDetailsFlyoutContainer = styled.div({
	width: "343px",
	padding: "16px 16px 0px",
	overflow: "hidden"
});

export const OrderDetailsFlyoutHeader = styled.div(({ theme }) => ({
	display: "flex",
	paddingBottom: "16px",
	justifyContent: "space-between",
	h5: {
		margin: 0,
		...theme.project.typography.heading.h5
	},
	svg: {
		cursor: "pointer"
	}
}));

export const OrderDetailsFlyoutContent = styled.div(({ theme }) => ({
	overflowX: "auto",
	height: "calc(100vh - 163px)",
	borderBottom: `1px solid ${theme.project.colors.fontColors.main}`
}));

export const OrderDetailsFlyoutShadowBlur = styled.div({
	marginBottom: "16px",
	boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.12)"
});

export const OrderDetailsFlyoutAlert = styled.div(({ theme }) => ({
	padding: "16px",
	backgroundColor: "var(--orange-50)",
	color: "var(--orange-500)",
	img: {
		float: "left",
		width: "18px",
		marginRight: "12px"
	},
	h6: {
		fontWeight: 500,
		fontSize: "16px",
		margin: 0
	},
	span: {
		fontWeight: 500,
		fontSize: "14px"
	},
	"> span:first-of-type": {
		lineHeight: "143%",
		letterSpacing: ".15px"
	},
	div: {
		marginTop: "12px",
		display: "flex",
		flexDirection: "column",
		"span:first-of-type": {
			fontSize: "16px",
			lineHeight: "143%",
			letterSpacing: ".15px"
		},
		"span:last-of-type": {
			lineHeight: "143%",
			letterSpacing: ".15px"
		}
	},
	button: {
		marginTop: "12px"
	}
}));

export const ItemsOnBackorderButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.allColors.hex.orange.orange500,
	borderColor: theme.project.colors.allColors.hex.orange.orange500,
	width: "100%",
	padding: "4px 8px",
	fontSize: "13px",
	display: "flex",
	alignItems: "center",
	svg: {
		height: "18px",
		width: "18px",
		marginLeft: "8px",
		marginTop: "-2px"
	}
}));

export const OrderDetailsFlyoutItemDetails = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const SkuDescription = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	marginTop: "8px",
	h6: {
		...theme.project.typography.heading.h6,
		margin: 0
	}
}));

export const OrderDetailsFlyoutResultBackground = styled.div(({ theme }) => ({
	background: theme.project.colors.allColors.hex.grayscale.gray50
}));

export const OrderDetailsFlyoutContainerAlertPartsGrid = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "12px",
	padding: "6px 0",
	div: {
		display: "flex",
		alignItems: "center",
		gap: "42px",
		"span:first-of-type": {
			width: "40px",
			...theme.project.typography.subtitle.subtitle2
		},
		"span:last-of-type": theme.project.typography.body.body1
	}
}));

export const OrderDetailsFlyoutContainerAlertPartsContainer = styled.div({
	padding: 16
});

export const ItemFlyoutDetailsContainer = styled.div(({ theme }) => ({
	label: {
		...theme.project.typography.subtitle.subtitle1
	},
	div: {
		display: "flex",
		gap: "12px",
		"span:first-of-type": {
			...theme.project.typography.subtitle.subtitle2
		},
		"span:last-of-type": {
			...theme.project.typography.body.body2,
			color: theme.project.colors.fontColors.secondary
		}
	},
	display: "flex",
	flexDirection: "column",
	img: {
		alignSelf: "start",
		margin: "8px 0"
	}
}));

export const OrderDetailsFlyoutFooter = styled.div(({ theme }) => ({
	position: "fixed",
	bottom: 0,
	width: "343px",
	right: "16px",
	padding: "19px 0 16px",
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	div: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	"div:first-of-type": {
		span: theme.project.typography.subtitle.subtitle2
	},
	"div:last-of-type": {
		span: theme.project.typography.subtitle.subtitle1
	}
}));
